import React ,
      {useEffect,
       useState, }    from "react"
import { Avatar , 
       Typography ,
       Box ,
       Grid,
       Container ,
       Button,
       Paper , }      from "@mui/material"
import { useHistory } from "react-router-dom"
import axios from 'axios'

// -------------------定数-------------------
const OpeningMusic   = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F01%20%EF%BD%9E%E3%82%AA%E3%83%BC%E3%83%95%E3%82%9A%E3%83%8B%E3%83%B3%E3%82%AF%E3%82%99%EF%BD%9E.wav?alt=media&token=51d966d0-66c9-49f4-bbd7-14809288d135"
const GameMusic      = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F21%20%E3%83%9E%E3%82%B5%E3%82%AD%E3%81%AE%E3%82%82%E3%81%A8%E3%81%B8%EF%BC%8D%E3%83%8F%E3%83%8A%E3%82%BF%E3%82%99%E3%82%88%E3%82%8A.wav?alt=media&token=77399b16-4558-4b95-ac73-c458c8ae3a52"
const PokemonBatle   = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F07%20%E6%88%A6%E3%81%84%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=8dacd0f2-c1ee-4394-85e3-0eaca290ea15"

function PokemonMusicPlay() {
  // 音楽が流れる
  const [audio]           = useState(new Audio(OpeningMusic))
  const [gameMusic]       = useState(new Audio(GameMusic))
  const [battleAudio]     = useState(new Audio(PokemonBatle))
  const [isPlaying, setIsPlaying] = useState(false)

  // オープニング音楽を再生
  const startaudioPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    audio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      audio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }
  // ゲーム音楽を再生
  const startGameMusicPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    gameMusic.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      gameMusic.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // バトル音楽を再生
  const startbattleAudioPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    battleAudio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      battleAudio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // すべての音楽を停止する
  const AllMusicPause = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
  }

  const GetKanji = async () => {
    const url = 'https://kanjialive-api.p.rapidapi.com/api/public/kanji/前'
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '70e202a520mshb60567aec6f7fb3p1c946bjsn435d63484a08',
        'X-RapidAPI-Host': 'kanjialive-api.p.rapidapi.com'
      }
    };

    try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      const kstroke = result.kanji.strokes;
      console.log(kstroke);
    } catch (error) {
      console.error('Error:', error.message);
    }
  }

  // 初回起動
  useEffect(() => {
  },[])

  return (
    <Container maxWidth="lg">
      <Box sx={{ flexGrow: 1,
                   bgcolor: '#f5f5f5' }}>

          {/* ボタン表示領域 */}
          <Grid container spacing={2}>
            <Grid item xs={4} align="center">
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ borderRadius: '20px' }}
                onClick={startaudioPlay}>
                オープニング音楽再生
              </Button>
            </Grid>
            <Grid item xs={4} align="center">
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ borderRadius: '20px' }}
                onClick={startGameMusicPlay}>
                ゲーム音楽再生
              </Button>
            </Grid>
            <Grid item xs={4} align="center">
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ borderRadius: '20px' }}
                onClick={startbattleAudioPlay}>
                バトル音楽再生
              </Button>
            </Grid>
            <Grid item xs={12} align="center">
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ borderRadius: '20px' }}
                onClick={AllMusicPause}>
                音楽停止
              </Button>
            </Grid>
            <Grid item xs={12} align="center">
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ borderRadius: '20px' }}
                onClick={GetKanji}>
                漢字ゲット
              </Button>
            </Grid>
          </Grid>
        <br/>
      </Box>
    </Container>
  );
}

export default PokemonMusicPlay